module.exports = __webpack_public_path__ + "img/undraw_reading_time_gvg0.255090fe.svg";